import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useApi } from "@/lib/api";
import { MEDIA_AGE } from "@/lib/brand";
import { Hero, Marquee } from "@/components/home/Hero";
import { UpcomingSection } from "@/components/home/UpcomingSection";
import { ThisWeekBanner } from "@/components/home/ThisWeekBanner";
import { CollageSection } from "@/components/home/CollageSection";
import { FeaturedSplit } from "@/components/home/FeaturedSplit";
import { ArticleCard } from "@/components/site/ArticleCard";
import { LatestEntries } from "@/components/site/LatestEntries";
import { SectionHeading } from "@/components/site/SectionHeading";
import { Container } from "@/components/site/PageHeader";
import { NewsletterSection } from "@/components/site/NewsletterForm";

const ARRIVAGES_IMG = "/brand/arrivages.jpg";
const PODCAST_IMG = "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1600&q=70";

const LatestNews = () => {
  const { data = [] } = useApi("/news", { limit: 4 });
  return (
    <section className="py-24 md:py-32 border-t border-white/10" data-testid="home-news-section">
      <Container>
        <div className="flex flex-col xl:flex-row xl:items-end justify-between gap-8 mb-16">
          <SectionHeading top="Le magazine" bottom="dernières chroniques" outline testId="home-news-title" />
          <Link to="/news" data-testid="home-all-news-btn" className="inline-flex items-center gap-3 text-white font-display uppercase text-xl hover:text-primary transition-colors">
            Tout le magazine <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {data.slice(0, 4).map((n, i) => <ArticleCard key={n.id} item={n} index={i} />)}
        </div>
      </Container>
    </section>
  );
};

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <ThisWeekBanner />
      <UpcomingSection />
      <LatestNews />
      <FeaturedSplit
        testId="home-arrivages-feature"
        image={ARRIVAGES_IMG}
        label="Côté radio"
        top="Les arrivages"
        bottom="en playlist"
        text="Les dernières entrées dans la playlist de la radio LGTDZ."
        cta="Toute la playlist"
        to="/arrivages"
      >
        <LatestEntries count={5} testId="home-top-tracks" />
      </FeaturedSplit>
      <FeaturedSplit
        testId="home-podcasts-feature"
        reverse
        image={PODCAST_IMG}
        label="Réécoute"
        top="Podcasts"
        bottom="& sessions live"
        text="Sets, concerts en réécoute, rap talks et premières radiophoniques : Vax 1 en hommage à DJ Mehdi, Akrobatik, Verb T et EL9SIX à Panke Culture, et bien d'autres."
        cta="Écouter les podcasts"
        to="/radio#podcasts"
      />
      <CollageSection />
      <section className="border-t border-white/10 py-20 md:py-28" data-testid="home-support-section">
        <Container className="flex flex-col md:flex-row md:items-center justify-between gap-10">
          <h2 className="uppercase text-[8vw] sm:text-5xl lg:text-6xl leading-[0.95]">
            <span className="font-display text-white block">LGTDZ</span>
            <span className="font-thin-brand text-white block pl-[8%]">se construit ici</span>
          </h2>
          <div className="max-w-md">
            <p className="text-zinc-300 text-lg">{MEDIA_AGE} ans, des milliers d'articles, plus de 200 événements. Rejoins la communauté dès 2 € par mois pour construire l'indépendance du média — sans pub ni logique promotionnelle contrainte.</p>
            <Link to="/soutenir" data-testid="home-support-btn" className="mt-8 inline-flex items-center gap-3 bg-primary text-white font-display uppercase text-xl px-8 py-4 hover:bg-white hover:text-black transition-colors duration-200">
              Soutenir LGTDZ <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </Container>
      </section>
      <NewsletterSection />
    </>
  );
}
